module.exports = __webpack_public_path__ + "img/marker-in-service-point.951a3d39.svg";